"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _createStyled = _interopRequireWildcard(require("../../../utils/createStyled"));

var _renderprops = require("react-spring/renderprops");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject()),
    Hint = (0, _renderprops.animated)(_createStyled.Styled.Div);

function template() {
  var _this = this;

  var hidden = this.state.hidden,
      styles = this.compileStyled(_index["default"]),
      _this$props = this.props,
      CloseIcon = _this$props.theme.closeIcon,
      closeAvailable = _this$props.closeAvailable,
      icon = _this$props.icon,
      className = _this$props.className;
  var close = null;

  if (closeAvailable) {
    close = icon || _react["default"].createElement(_IconButton["default"], null, _react["default"].createElement(Div, {
      styles: styles.closeIcon
    }, _react["default"].createElement(CloseIcon, null)));
    close = _react["default"].createElement(Div, {
      styles: styles.close,
      onClick: this._hide
    }, close);
  }

  return _react["default"].createElement(_renderprops.Transition, {
    items: hidden,
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    "native": true,
    config: _renderprops.config.stiff
  }, function (hidden) {
    return !hidden && function (props) {
      return _react["default"].createElement(Hint, {
        style: props
      }, _react["default"].createElement(Div, {
        className: className,
        styles: styles.root
      }, _react["default"].createElement(Div, {
        styles: styles.content
      }, close, _this.props.children)));
    };
  });
}